import Model, {
  attr,
  belongsTo,
  type AsyncBelongsTo,
} from '@warp-drive/legacy/model';
import type { Type } from '@warp-drive/core/types/symbols';
import type { FragmentArray } from 'ember-data-model-fragments/array/fragment';
import { fragmentArray } from 'ember-data-model-fragments/attributes';
import type StatusSyncError from 'linced-admin/models/auth/status-sync-error';
import type Person from 'linced-admin/models/person';

// Proto: auth.Status.
export default class Status extends Model {
  declare [Type]: 'auth/status';

  // createTime is when the resource was created in seconds from the epoch.
  @attr('number')
  declare createTime: number | undefined;

  // updateTime is the last time the resource was modified in seconds from
  // the epoch.
  @attr('number')
  declare updateTime: number | undefined;

  // requesterId is the personId of the user who created the status resource.
  @belongsTo('person', { async: true, inverse: null })
  declare requesterId: AsyncBelongsTo<Person>;

  // status contains the current in flight status of the request.
  @attr('number', { defaultValue: 1 })
  declare status: number; // State

  // count is the number of records to be processed.
  @attr('number', { defaultValue: 0 })
  declare count: number;

  // created is the number of records of count that have been created.
  @attr('number', { defaultValue: 0 })
  declare created: number;

  // updated is the number of records of count that have been updated.
  @attr('number', { defaultValue: 0 })
  declare updated: number;

  // failed is the number of records of count that have failed.
  @attr('number', { defaultValue: 0 })
  declare failed: number;

  // type is the status type - either 'user' or 'client'.
  @attr('string', { defaultValue: 'user' })
  declare type: string;

  // syncErrors provides a list of any sync errors encountered.
  @fragmentArray('auth/status-sync-error')
  declare syncErrors: FragmentArray<StatusSyncError>;
}
